import React, { Fragment } from "react";

export default ({ data }) => {
  return (
    <Fragment>
      <h2 style={{ marginTop: "0", marginBottom: "7.5px" }}>{data.total}</h2>
      <p style={{ marginTop: "0", paddingTop: "0", textAlign: "center" }}>
        {data.fname}’s Friendraising Donations for
        <br />
        {data.charity}
      </p>
    </Fragment>
  );
};
